import { useEffect, useState } from 'react';
import { Autocomplete, IconButton, Stack, TextField, Typography } from "@mui/material";
import Iconify from 'src/components/Iconify';
import useAuth from 'src/careflow/ph-core/authentication/hook/useAuth';
import uuidv4 from 'src/utils/uuidv4';
import { useStyles } from 'src/careflow/helpers/workflowStyle';

const CustomSelectComponent = (props: any) => {

  const classes: any = useStyles({});
  const currentUser = useAuth().getCurrentUser();

  const {
    record,
    checklistItem,
    handler,
    data,
    allowEdit
  } = props?.others;

  const items = 
    data &&
    data.length > 0 ? 
    [
      ...data
        .filter((i: any) => i?.userName === currentUser?.userName)
        .map((i: any) => ({
          label: `${i?.firstName} ${i?.lastName} (Me)`,
          id: i?.userName
        })),
      ...data
        .filter((i: any) => i?.userName !== currentUser?.userName)
        .map((i: any) => ({
          label: `${i?.firstName} ${i?.lastName}`,
          id: i?.userName
        }))
    ] : [{ label: '', id: '' }];

  const [inputValue, setInputValue] = useState('');
  const [edit, setEdit] = useState(false);

  const metadata = checklistItem && checklistItem?.metadata ? JSON.parse(checklistItem?.metadata) : {};
  const { className = null } = metadata?.ui || {};
  const [value, setValue] = useState<any>(null);
  const safeClassName = className && classes && classes[className] ? classes[className] : undefined;

  useEffect(() => {
    const getValue: any = items?.
      find((e) => e?.id === record?.ownedBy);
    setValue(getValue)
  }, [record]);

  return (
    <>
      {!edit ? (
        <Stack direction="row" alignItems="center">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="row">
              <Typography sx={{ fontSize: 12 }}>Assigned Owner:</Typography>&nbsp;
              <span style={{ fontWeight: 'bold', color: 'green', fontSize: 12 }}>{value?.label}</span>
            </Stack>
          </Stack>
          {allowEdit && 
            <Stack direction="column" alignItems="center">
              <IconButton 
                size='small'
                onClick={ () => setEdit(true)}
              >
                <Iconify icon="eva:edit-outline" />
              </IconButton>
            </Stack>
          }
        </Stack>
      ) : (
        <Stack direction="row" alignItems="center">
          <Autocomplete
            disablePortal={false}
            fullWidth
            id="combo-box-demo"
            value={value}
            inputValue={inputValue}
            className={safeClassName}
            onInputChange={(event: any, newInputValue: any) => {
              setInputValue(newInputValue);
            }}
            options={items}
            renderInput={(params) => (
              <TextField 
                {...params} 
                fullWidth 
                label={`${props?.name || props?.elementName || ""} ${checklistItem?.isRequired ? "*" : ""}`.trim()}
              />
            )}
            renderOption={(props: any, option: any) => (
              <li {...props} key={uuidv4()}>
                {option?.label}
              </li>
            )}
            onChange={(event: any, username: any | null) => {
              if(!username) return;
              setValue(username);
              setEdit(false);
              handler({
                record,
                checklistItem,
                more: { selectedUser: username?.id },
              })
            }}
          />
          <Stack direction="column" alignItems="center">
            <IconButton 
              size='small'
              onClick={ () => setEdit(false)}
            >
              <Iconify icon="material-symbols:close-rounded" />
            </IconButton>
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default CustomSelectComponent;
